import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import PaymentType from 'models/enums/PaymentType';
import { useClaimJobPaymentItemProvider } from '../Finance.ClaimJobPaymentItem.Hooks';

export default function ClaimJobPaymentItemFilters() {
  const { lang, translate } = getLocales();
  const { isDealer } = useAuthStore();
  const { listApi, dealersApi, userApi, pageRouter } = useClaimJobPaymentItemProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search }))}
      filters={listApi?.body}
      onFilter={(newFilters) => {
        listApi?.execute(newFilters);
      }}
      onReset={() => {
        pageRouter.redirect(
          { ...pageRouter.params },
          {
            ...pageRouter.query,
            list: undefined,
          }
        );
      }}
      onOpen={() => {
        if (!userApi?.payload) userApi?.execute();
        if (!dealersApi?.payload && !isDealer) dealersApi?.execute((b) => b);
      }}
      render={({ tempFilters, setFilters }) => (
        <>
          <TextInput
            name="payeeName"
            label={lang.payeeName}
            value={tempFilters?.payeeName}
            onChange={setFilters}
            icon={<Icon class="if-quill-pen" />}
          />
          <SelectInput
            name="dealerId"
            label={lang.dealers}
            data={dealersApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-user-friends" />,
            }))}
            isMultiselect
            value={tempFilters?.dealerId}
            onChange={setFilters}
            disabled={isDealer}
            icon={<Icon class="fas-user-friends" />}
          />
          <SelectInput
            name="ownerId"
            label={lang.owner}
            data={userApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-user" />,
            }))}
            isMultiselect
            value={tempFilters?.ownerId}
            onChange={setFilters}
            icon={<Icon class="fas-user" />}
          />
          <SelectInput
            name="paymentMethodCode"
            label={lang.paymentMethod}
            data={Object.values(PaymentType).map((it) => ({
              id: it,
              title: translate(it),
            }))}
            value={tempFilters?.paymentMethodCode}
            onChange={setFilters}
          />
          <DateInput
            name="createdAtLocalFrom"
            label={lang.startDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.createdAtLocalFrom}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="createdAtLocalTo"
            label={lang.endDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.createdAtLocalTo}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
        </>
      )}
    />
  );
}
